import { render, staticRenderFns } from "./AddNewLesson.vue?vue&type=template&id=0bb92a7d&scoped=true"
import script from "./AddNewLesson.vue?vue&type=script&lang=js"
export * from "./AddNewLesson.vue?vue&type=script&lang=js"
import style0 from "./AddNewLesson.vue?vue&type=style&index=0&id=0bb92a7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb92a7d",
  null
  
)

export default component.exports